import React from 'react';

interface ShoulderShruggedProps {}

export function ShoulderShrugged(props: Readonly<ShoulderShruggedProps>) {
	return (
		<svg width={90} height={85} viewBox="0 0 90 85" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_11550)">
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M27.914 89.738v-3.735H17.681V74.707h-4.119v13.18c0 1.018.919 1.85 2.04 1.85h12.312z"
				/>
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.658 60.375h6.356c.826 0 1.449.806 1.5 1.783l.695 12.813c0 .97-.677 1.783-1.5 1.783h-7.645c-.823 0-1.545-.804-1.5-1.783l.595-12.813c.044-.98.673-1.783 1.499-1.783z"
				/>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M60.102 89.738v-3.735h10.233V74.707h4.119v13.18c0 1.018-.919 1.85-2.04 1.85H60.101z"
				/>
				<mask
					id="a"
					x={66}
					y={64}
					width={12}
					height={17}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M66.86 64.469h10.79v16.379H66.86v-16.38z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M75.525 60.398h-6.318c-.82 0-1.44.8-1.491 1.769l-.69 12.708c-.052.969.673 1.769 1.492 1.769h7.597c.82 0 1.52-1.225 1.476-2.196l-.576-12.281c-.044-.971-.67-1.769-1.49-1.769z"
					/>
				</g>
				<path
					fill="#282626"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M38.809 90.539v-9.687h9.866v9.687h-9.866z"
				/>
				<path
					fill="#373D4A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M40.645 75.875h9.864v5.307h-9.864v-5.307z"
				/>
				<mask
					id="b"
					x={21}
					y={23}
					width={45}
					height={62}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M21.816 23.523h43.61V84.86h-43.61V23.523z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M31.363 23.523h25.61c2.627 0 4.482 1.324 4.776 5.801l3.258 49.662c.294 4.48-2.153 5.803-4.776 5.803H28.107c-2.624 0-5.071-1.316-4.778-5.803l3.258-49.662c.295-4.486 2.15-5.8 4.776-5.8z"
					/>
				</g>
				<path
					fill="#3E454A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M65.222 80.852c-.1 3.138-2.388 4.094-4.826 4.094H28.078c-2.441 0-4.728-.952-4.828-4.094h41.972zM21.12 74.707c0 1.84-.455 2.047-2.503 2.047h-6.142c-.616 0-2.047 0-1.911-2.047H21.12zM77.628 74.707c0 1.84-.455 2.047-2.503 2.047h-6.142c-.616 0-2.047 0-1.911-2.047h10.556z"
				/>
				<path
					fill="#999"
					d="M62.59 49.863c.36-.46 1.682-2.494 2.1-3.199.419-.704.944-1.56 1.344-2.38.432-.887 1.193-2.367 1.74-3.444.466-.92 2.738-5.006.107-8.103-1.34-1.158-1.229-2.425-4.095-3.072-4.088-.922-6.185 1.08-10.117-.46-1.855-.727-2.785-1.76-3.684-3.305-.313-.538.041-2.954 0-3.461-.038-.456-.49-.815-1.047-.815l-10.882-.015c-.566 0-1.042.366-1.056.83-.02.685.323 2.88 0 3.46-.482 1.284-2.055 2.552-4.314 3.306-2.245.845-3.824.46-7.8.46-1.469 0-3.07 1.276-4.095 2.048-.782.589-1.824 3.312-2.048 4.095-.223.783.629 2.502 1.35 4.385.721 1.883 1.722 3.48 1.882 3.94.16.46 1.122 2.533 1.442 3.125.32.59 1.217 2.139 1.362 2.324.144.185.84 1.247 1.12 1.706.161.296.657 1.22.802 1.51.294.593 2.61 4.5 2.81 5.944.288 2.079.52 6.331.52 8.816-.334 3.948-.325 10.053-2.075 18.411-.197.943-.143 2.072 0 3.385.398 3.628 2.91 8.781 16.846 8.781s16.035-7.632 16.179-8.781c.143-1.149.178-1.974 0-3.385-.178-1.411-2.138-13.978-2.436-18.411-.13-1.928 0-6.842.298-8.816.33-2.195 1.6-5.36 2.757-7.338.23-.392.63-1.082.99-1.541z"
				/>
				<path
					fill="#7F7F7F"
					d="M38.096 2.258C39.126 1.65 41.56 1 43.05 1c1.49 0 3.748.113 5.592 1.258 1.844 1.145 2.518 1.992 2.94 2.69.423.7 1.354 2.774 1.71 4.497.389 1.887.24 3.36.163 3.995-.199 1.631-1.077 4.415-1.827 5.755-.749 1.34-2.986 5.416-4.083 6.72-1.097 1.306-2.004 1.701-4.304 1.701-2.036 0-3.348-1.188-4.246-2.166-.9-.979-3.426-5.265-3.766-5.824-.34-.56-1.777-3.379-2.003-5.254-.226-1.875-.177-3.773 0-4.927.177-1.154.92-3.133 1.805-4.496.884-1.363 2.035-2.083 3.065-2.691zM68.744 57.82a4.463 4.463 0 001.56.653 4.346 4.346 0 001.677.02 4.187 4.187 0 001.537-.617 4.079 4.079 0 001.162-1.159c.467-.704.779-1.863.711-2.387-.043-.34-.109-.81-.196-1.239-.166-.848-.365-1.297-.697-2.101-.672-1.616-.576-1.25-1.213-2.64-.562-1.78-1.137-3.22-1.905-6.665a41.773 41.773 0 00-2.026-6.556c-.224-.52-.438-1.007-.623-1.453l-.016-.054c-.296-.618-.562-1.193-.778-1.63a5.958 5.958 0 00-1.73-1.779 6.531 6.531 0 00-2.293-.95 6.359 6.359 0 00-2.46-.02c-.808.153-1.59.376-2.25.915a4.675 4.675 0 00-1.15 1.537c-.214.457-1.004 1.64-.875 4.31.034.701.232 1.431.286 1.61.053.178-.051-.165 0 0 .564 1.892 1.323 3.552 2.268 5.234.954 1.697 1.885 2.873 1.885 2.873.874 1.246 1.078 1.43 1.799 2.572.656 1.04 1.377 2.365 1.99 3.511.493 1.182 1.322 2.823 1.524 3.294.334.777.478 1.266.79 1.733.31.468.556.672 1.023.988z"
				/>
				<path
					fill="#999"
					d="M74.749 78.454c-.106.097-2.025 2.044-2.982 1.94-1.057-.386-1.243-1.128-1.238-1.415.009-.447 1.411-3.383 1.447-4.49.044-1.348-.412-2.448-1.055-3.416 0 0-.32.848-.958 1.513-.545.568-.374 2.025-1.217 1.99-.843-.033-.873-2.129-.834-2.78.048-.814.18-1.815.283-2.273.104-.459.387-1.102.691-1.66.383-.701 1.047-1.699 1.16-1.837 0 0 .238-.365.785-.543 0 0 .87-.124 1.507-.055.638.07 1.141.394 1.446.648.305.254 1.101 1.486 1.509 1.981.407.496.965 1.728.962 1.79 0 0 .324.716.693 1.777.118.609.808 1.466.808 1.466.377.493.408.848.408.848.122.655-.14.999-.691 1.328-.493.34-.882 1.357-1.345 1.744-.463.387-1.273 1.346-1.38 1.444z"
				/>
				<path
					fill="#999"
					d="M69.525 68.1c.43.214.842.306 1.415.328.573.023.894-.009 1.171-.087.331-.093.733-.223 1.04-.502.382-.35.667-1.345.757-1.67 1.068-3.864.342-1.845 1.513-4.856.494-2.252.624-2.95.664-4.018.04-1.068-.605-1.843-.979-2.184-.374-.342-1.005-.736-1.944-.836-1.219-.055-1.685-.013-2.686.318-.86.284-1.201.744-1.49.996-.347.302-.842 1.235-.934 1.646-.252 1.306-.136 1.566.156 2.908.26 1.067.243 1.614.484 2.693.214 1.199.275 2.004.274 2.617 0 .507-.094 1.531-.056 1.884.038.352.206.56.615.763zM14.56 79.68c.106.098 2.025 2.044 2.981 1.94 1.058-.386 1.244-1.128 1.238-1.415-.008-.447-1.41-3.382-1.447-4.49-.044-1.348.413-2.448 1.055-3.415 0 0 .322.847.959 1.512.544.568.373 2.025 1.216 1.991.843-.034.874-2.13.835-2.78-.048-.815-.18-1.816-.284-2.274-.103-.458-.386-1.101-.69-1.659-.383-.702-1.048-1.7-1.161-1.837 0 0-.238-.366-.784-.544 0 0-.87-.124-1.507-.055-.638.07-1.142.395-1.447.649-.304.254-1.101 1.486-1.508 1.981-.407.495-.966 1.727-.962 1.79 0 0-.325.715-.693 1.776-.119.61-.808 1.466-.808 1.466-.377.494-.409.849-.409.849-.122.654.14.998.692 1.327.493.341.882 1.358 1.345 1.745.462.387 1.273 1.346 1.379 1.443z"
				/>
				<path
					fill="#7F7F7F"
					d="M18.95 60.85a4.574 4.574 0 01-1.555.811 4.215 4.215 0 01-1.7.144 4.009 4.009 0 01-2.815-1.698c-.505-.717-.872-1.933-.827-2.496.03-.367.075-.873.144-1.338.131-.918.313-1.412.614-2.295.61-1.774.528-1.377 1.113-2.908.491-1.94 1.01-3.522 1.638-7.255.4-2.419.99-4.81 1.764-7.149.204-.57.4-1.108.567-1.597l.014-.06c.273-.68.517-1.314.716-1.796a6.523 6.523 0 011.677-2.026 6.69 6.69 0 012.283-1.184 6.166 6.166 0 012.494-.2c.826.104 1.629.285 2.322.812a4.781 4.781 0 011.235 1.557c.237.472 1.09 1.677 1.078 4.537a8.704 8.704 0 01-.218 1.74c-.046.195.044-.179 0 0-.49 2.062-1.185 3.89-2.07 5.756-.892 1.882-1.783 3.205-1.783 3.205-.832 1.395-1.03 1.605-1.711 2.878-.62 1.16-1.292 2.626-1.862 3.895-.448 1.298-1.217 3.11-1.401 3.629-.304.854-.429 1.386-.724 1.908s-.535.758-.994 1.13z"
				/>
				<path
					fill="#999"
					d="M19.261 70.463c-.403.272-.802.414-1.369.5-.566.087-.89.09-1.174.038-.34-.062-.754-.156-1.091-.416-.42-.326-.819-1.343-.945-1.675-1.508-3.954-.553-1.907-2.064-4.95-.751-2.318-.96-3.04-1.123-4.16-.163-1.12.388-2.007.72-2.408.333-.4.915-.884 1.837-1.094 1.205-.19 1.674-.197 2.706.041.889.206 1.28.653 1.596.886.38.28.98 1.209 1.118 1.631.401 1.348.316 1.635.18 3.08-.135 1.153-.055 1.728-.17 2.89-.074 1.287-.042 2.142.029 2.787.059.534.27 1.603.273 1.978.003.376-.14.613-.523.872z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_11550">
					<path fill="#fff" d="M0 0H90V85H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
